import { Helmet } from "react-helmet-async";

const DEFAULT_IMAGE = `${process.env.REACT_APP_BACKEND_URL}/og-image.png`;

export default function Seo({ title, description, jsonLd, image, imageAlt }) {
  const shareImage = image || DEFAULT_IMAGE;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={shareImage} />
      <meta property="og:image:alt" content={imageAlt || "Androgen Health — specialist testosterone care, delivered online"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={shareImage} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
